export default __webpack_public_path__ + "static/media/stayUp2.9949674d.jpeg";